import classNames from "classnames";
import {Link} from "@/shared/ui/Link";
import {ProductCharacteristic} from "../../model/types";
import {ProductInsertCharacteristics} from "./ProductInsertCharacteristics";
import styles from "./ProductCharacteristics.module.scss";

type Props = {
    item: ProductCharacteristic
    previewLength: number;
}

export const ProductCharacteristicsItem = ({item, previewLength}: Props) => {
    switch (item.type) {
        case "link":
            return (
                <Link href={item.href} className={styles.item}>
                    <span className={styles.label}>{item.label}</span>
                    <span className={classNames(styles.value, styles[item.type])}>{item.value}</span>
                </Link>
            );

        case "insert":
            return (
                <ProductInsertCharacteristics insert_details={item.value} previewLength={previewLength} />
            );

        default:
            return (
                <div className={styles.item}>
                    <span className={styles.label}>{item.label}</span>
                    <span className={classNames(styles.value, styles[item.type])}>{item.value}</span>
                </div>
            );
    }
}
